import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { elsewhereKeys } from 'helpers/events'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { dispatchSendSocketMessage } from 'store/dispatcher'
import { _isIframeShared } from 'store/selectors/WebSocket'

const events = {
    VISIBILITY_CHANGE: 'visibilitychange',
    FOCUS: 'focus',
    BLUR: 'blur',
}

const visibilityStates = {
    VISIBLE: 'visible',
    HIDDEN: 'hidden',
}

export default function useUserActivityTracker({ isTeacher }) {
    const [isUserOnPage, setIsUserOnPage] = useState(true)

    useEffect(() => {
        if (isTeacher) return

        // Emitted After User Come's Back To Page From A New Window.
        const handleUserOnWindow = () => setIsUserOnPage(true)

        // Emitted After User Navigates Away To A New Window.
        const handleUserOffWindow = () => setIsUserOnPage(false)

        // Emitted After A User Changes Tab and Maximises / Minimises Current Tab
        const handleDOMVisibilityChange = () => {
            const visibilityState = document.visibilityState
            const isVisible = visibilityState === visibilityStates.VISIBLE
            setIsUserOnPage(isVisible)
        }

        document.addEventListener(
            events.VISIBILITY_CHANGE,
            handleDOMVisibilityChange
        )
        window.addEventListener(events.FOCUS, handleUserOnWindow)
        window.addEventListener(events.BLUR, handleUserOffWindow)

        return () => {
            document.removeEventListener(
                events.VISIBILITY_CHANGE,
                handleDOMVisibilityChange
            )
            window.removeEventListener(events.FOCUS, handleUserOnWindow)
            window.removeEventListener(events.BLUR, handleUserOffWindow)
        }
    }, [isTeacher])

    useUserActivitySender(isUserOnPage)

    return { isUserOnPage }
}

const useUserActivitySender = isUserOnPage => {
    const isIframeShared = useSelector(_isIframeShared)
    const { isWhiteboardMode, isDefaultScreenShare } = useVideoContext()

    useEffect(() => {
        if (isIframeShared || isWhiteboardMode || isDefaultScreenShare) return

        const data = {
            action: elsewhereKeys.ELSEWHERE,
            key: elsewhereKeys.USER_IS_AWAY,
        }
        if (isUserOnPage) data.key = elsewhereKeys.USER_IS_BACK
        dispatchSendSocketMessage(data)
    }, [isUserOnPage, isIframeShared, isWhiteboardMode])
}
